<template>
  <div class="container">
    <div class="search">
      <el-input
        :placeholder="$t('search.placeholderProName')"
        v-model="keywords"
      ></el-input>
      <div class="button" @click="search()">{{ $t("common.search") }}</div>
    </div>
    <div class="rightContent" v-if="RecommendExhibits.length > 0">
      <!-- 右侧内容区域的子栏目开始 -->

      <div
        class="rightBox"
        v-for="(item, index) in RecommendExhibits"
        :key="index"
        @click="goDetail(item.obj.id)"
      >
        <div>
          <div class="titl comment">{{ item.obj.exhibitsName }}</div>
          <div class="english comment">{{ item.obj.column23 }}</div>
          <div class="txt">{{ item.obj.column17 }}</div>
          <div class="backImg">
            <img
              :src="baseUrl + item.obj.exhibitsCoverImg"
              alt=""
              v-if="item.obj.exhibitsCoverImg.includes('/hz/hzupload')"
            />
            <img src="../../../static/占位-展品-列表.png" alt="" v-else />
          </div>
          <div class="companyName">
            {{ item.obj.hzExhibitor.companyNameC }}
          </div>
          <div class="delItem" @click.stop="delItem(item.id)">
            <img src="../../../static/icon_del.png" alt="" />
          </div>
        </div>
      </div>

      <div v-show="RecommendExhibits.length === 0" class="nodata">
     
        <div>
          <img alt="" src="../../../static/empty.png" />
        </div>
     
        <div class="tip">
           <div>{{ $t("search.nocCollect") }}</div>
        </div>

      </div>
    </div>
    <div class="boxImg" v-else>
      <img src="../../../static/empty.png" alt="" />
      <div>{{ $t("search.nocCollect") }}</div>
    </div>
  </div>
</template>
<script>
import { getColProductsLists, delCollect } from "../../../../api/collection.js";
import { forMat, backProductDetail } from "../../../../utils/common.js";

export default {
  data() {
    return {
      baseUrl: forMat(),
      productTypeList: null,
      type: '',
      keywords: '',
      RecommendExhibits: [],
      productDetailUrl: backProductDetail(),
    };
  },
  created() {
   const params = {
      keyword: '',
    };
    this.getLists(params);
  },
  methods: {

    goDetail(id) {
      window.location.href = this.productDetailUrl + '?id=' + id;
    },
    async getLists(params) {
      try {
        const { data } = await getColProductsLists(params);
        if (data.code === 200) {
          this.RecommendExhibits = data.data;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },

    search() {
      // 搜索函数 type keywords
      const params = {
        keyword: this.keywords,
      };
      this.getLists(params);
    },

    handleCascader() {},

    async delItem(id) {
      const params1 = {
        id: id,
      };
      try {
        const { data } = await delCollect(params1);
        if (data.code === 200) {
          // this.lists = data.data;
          const params = {
            keyword: this.keywords,
          };
          this.getLists(params);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },



  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  padding-top: 15px;
  background-color: white;
    min-height:calc(100vh - 176px);
  .search {
    display: flex;
    padding: 0px 15px;
    box-sizing: border-box;
    .button {
      width: 100%;
      height: 36px;
      background: #006fb8;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .rightContent {
      display: grid;
      grid-template-columns: repeat(2,48%);
      justify-content: space-between;
      padding: 0px 15px;
      box-sizing: border-box;
      margin-top: 20px;
      grid-column-gap: 10px;
      grid-row-gap: 10px;
    .rightBox {
      height: fit-content;
      background-color: white;

      border: 1px solid #e0e0e0;
      cursor: pointer;
      position: relative;

      .titl {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #006fb8;
        line-height: 23px;
        padding: 10px 0px 0px 10px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
        max-width: 158px;
      }
      .english {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 250px;
        font-size: 10px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #006fb8;
        line-height: 12px;
        padding: 5px 0px 0px 10px;
        box-sizing: border-box;
      }
      .txt {
        max-width: 250px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        padding: 5px 0px 0px 10px;
        box-sizing: border-box;
      }
      .backImg {
        padding-top: 23px;
        margin: 0 auto;
        width: 135px;
        height: 103px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
          display: block;
        }
      }
      .companyName {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 11px;

        padding: 15px 8px;
        box-sizing: border-box;
        text-align: center;
        line-height: 15px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
      }

      .delItem {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
        }
      }
      &:hover {
        .titl {
          color: #006fb8;
        }

        .english {
          color: #006fb8;
        }
      }
    }
  }
}
</style>
<style scoped>
.el-input {
  width: 240px;
  height: 32px;
}
.container >>> .el-input__inner {
  width: 240px;

  height: 36px;
  line-height: 36px;
}
.container >>> .el-input__icon {
  line-height: 36px;
}
</style>
<style lang="scss" scoped>
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 220px;
    height: 180px;
    margin: 0 auto;
  }
}
</style>
